import { buttonStyle } from '@florencelabs/button';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { getReasonForVisitLabel } from '@provider-directory/components/availability/availability.model';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';
import { phoneToTelUri } from '@provider-directory/components/phone-number';
import { useTrackAndOpenCall } from '@provider-directory/hooks/useTrackAndOpenCall';

interface EmptyStateRfvProps {
  reasonForVisit: string;
}

export const EmptyStateRfv = ({
  reasonForVisit,
}: EmptyStateRfvProps): ReactElement => {
  const { t } = useTranslation();
  const {
    config: { name: orgName, decisionTree },
  } = useOrgContext();
  const trackAndOpenCall = useTrackAndOpenCall();

  const phone = decisionTree.mainPhoneNumber;
  const reasonForVisitLabel = getReasonForVisitLabel(reasonForVisit, t);

  return (
    <>
      <div className={'flex flex-col items-center gap-2'}>
        <span className={'text-heading-xlarge font-semibold'}>
          {t('searchResults.noProvidersAvailableTitle')}
        </span>
        <div className={'max-w-prose text-center'}>
          <p>
            {t('searchResults.noProvidersAvailableBody1', {
              reasonForVisit: reasonForVisitLabel,
            })}
          </p>
          <p>
            {t('searchResults.noProvidersAvailableBody2', {
              phoneDisplay: phone,
            })}
          </p>
        </div>
      </div>
      <a
        href={phoneToTelUri(phone)}
        data-testid={'rfv-no-providers-call-btn'}
        className={buttonStyle({ variant: 'clientMain', size: 'small' })}
        aria-label={t('aria.callLocation', { locationName: orgName })}
        rel={'noopener noreferrer'}
        onClick={trackAndOpenCall(phone)}
      >
        {t('searchResults.noProvidersAvailableCallCta', {
          phoneDisplay: phone,
        })}
      </a>
    </>
  );
};
